import { styled } from "@mui/system";
import React, { useEffect, useState } from "react";
import Templates from "./Templates";

const MainContainer = styled("div")({
  paddingLeft: "24px",
  width: "calc(100% - 100px)",
  display: "flex",
  flexDirection: "column",
  boxSizing: "border-box",
  "@media (max-width: 650px)": {
    alignItems: "center",
    width: "100%",
    minHeight: "100vh",
    paddingLeft: "0px",
  },
});

/**
 *
 * @param {*} categorySelected The current categoryID selected
 * @param {Object} categoryMapping Contains mapping of categoryID -> Name
 * @param {Array} allTemplates Array of all the templates available
 * @returns Marketplace templates container which includes search bar and all marketplace
 * templates
 */
const MarketplaceTemplates = ({
  categorySelected,
  categoryMapping,
  allTemplates,
}) => {
  const [filteredTemplates, setFilteredTemplates] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (search.length === 0 && categorySelected === 0) {
      setFilteredTemplates(allTemplates);
      return;
    }

    const newFilteredTemplates = allTemplates.filter(
      ({ name, author, categories }) => {
        let nameCheck = false;
        let authorCheck = false;
        let categoriesCheck = categorySelected === 0;
        if (name !== null) {
          nameCheck = name.toLowerCase().includes(search);
        }
        if (authorCheck !== null) {
          authorCheck = author.toLowerCase().includes(search);
        }

        if (categories !== null && categorySelected !== 0) {
          categoriesCheck = categories.includes(categorySelected);
        }

        return (nameCheck || authorCheck) && categoriesCheck;
      }
    );

    setFilteredTemplates(newFilteredTemplates);
  }, [categorySelected]);

  const handleSearch = (e) => {
    e.preventDefault();
    const word = e.target.value.toLowerCase();
    setSearch(word);
    let search = word;

    if (search.length === 0 && categorySelected === 0) {
      setFilteredTemplates(allTemplates);
      return;
    }

    const newFilteredTemplates = allTemplates.filter(
      ({ name, author, categories }) => {
        let nameCheck = false;
        let authorCheck = false;
        let categoriesCheck = categorySelected === 0;
        if (name !== null) {
          nameCheck = name.toLowerCase().includes(search);
        }
        if (authorCheck !== null) {
          authorCheck = author.toLowerCase().includes(search);
        }

        if (categories !== null && categorySelected !== 0) {
          categoriesCheck = categories.includes(categorySelected);
        }

        return (nameCheck || authorCheck) && categoriesCheck;
      }
    );

    setFilteredTemplates(newFilteredTemplates);
  };

  return (
    <MainContainer>
      <Templates
        templates={filteredTemplates}
        categorySelected={categorySelected}
        categoryMapping={categoryMapping}
      />
    </MainContainer>
  );
};

export default MarketplaceTemplates;
